// eslint-disable-next-line monorepo/no-internal-import
import {Locale} from '@aboutyou/config/src/locale';
import type {Request} from 'express';

export enum SERVER_RENDERING_MODE {
  SSR = 'ssr', // Full Server-Side Rendering, no optimizations
  SSR_SEO_BOT = 'ssr_seo_bot', // Server-Side Rendering optimized for SEO bots
  SSR_REAL_USER = 'ssr_real_user', // Server-Side Rendering optimized for real users
  CSR = 'csr', // Basic skeleton SSR and then Client-Side Rendering
}

const RENDERING_MODIFYING_HEADERS = {
  DEVICE: 'X-UA-Device',
  CLIENT_SIDE_RENDERING: 'X-CSR',

  // if the page is rendered through a service worker we expect that it's a real user and no bot, we can therefore activate a client mode that removed certain information from the page for faster load times.
  SERVICE_WORKER_NAVIGATION_PRELOAD: 'Service-Worker-Navigation-Preload',
};

export const getServerRenderingMode = ({
  req,
  locale,
}: {
  req: Request;
  locale?: Locale;
}) => {
  if (
    req.query.ssr === '0' ||
    req.header(RENDERING_MODIFYING_HEADERS.CLIENT_SIDE_RENDERING) === '1'
  ) {
    return SERVER_RENDERING_MODE.CSR;
  }

  if (
    req.header(RENDERING_MODIFYING_HEADERS.SERVICE_WORKER_NAVIGATION_PRELOAD) &&
    locale !== Locale.nl_NL // => we want to render the page with all the information for real users and also for bots in the NL as an experiment for two months -> ASFE-11182
  ) {
    return SERVER_RENDERING_MODE.SSR_REAL_USER;
  }

  if (
    req.header(RENDERING_MODIFYING_HEADERS.DEVICE)?.includes('bot') ||
    req.query.enableBotMode === '1'
  ) {
    return SERVER_RENDERING_MODE.SSR_SEO_BOT;
  }

  // Default rendering mode is full SSR
  return SERVER_RENDERING_MODE.SSR;
};
